// components/PopupVendor/VendorProfileHeader.js
import React from 'react';

const VendorProfileHeader = ({
                                 name,
                                 isFavorite,
                                 handleToggleFavorites,
                                 foundation_year,
                                 service_type,
                                 isCurrentUserVendorOwner,
                                 handlerShowEditProfilePopup
                             }) => {

    const renderServiceType = () => {
        if (service_type && service_type.service_type_name) {
            return (
                <span className="vendor__status vendor__status-active">{service_type.service_type_name}</span>
            );
        }
        return null;
    };

    return (
        <div className="profile__header">
            <div className="vendor__header">
                <h1 className="vendor__name">{name || "Vendor Name"}</h1>
                <button
                    className={`favorites ${isFavorite ? 'added' : ''}`}
                    onClick={handleToggleFavorites}
                >
                    <svg viewBox="0 0 20 20"> {/* Added viewBox for better scaling */}
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M1.58733 3.10072C3.70393 0.940385 7.13582 0.940385 9.25246 3.10072L10.0323 3.89665L10.7475 3.16683C12.8641 1.0065 16.296 1.0065 18.4127 3.16683C20.5293 5.32717 20.5292 8.82998 18.4127 10.9904L10.4695 19.0901C10.4418 19.1184 10.5003 19.068 10.4695 19.0901C10.2068 19.2849 9.79324 19.2991 9.5566 19.0576L1.58757 10.9239C-0.52903 8.76353 -0.529268 5.26111 1.58733 3.10072Z"></path>
                    </svg>
                </button>
                {foundation_year && (
                    <span> Founded In {foundation_year} </span>
                )}
                {renderServiceType()}
            </div>
            {isCurrentUserVendorOwner && (
                <button className="button no-style" onClick={handlerShowEditProfilePopup}>
                    <img src="/assets/icon--edit-Z9QfuMgm.svg" alt="Edit"/> Edit profile
                </button>
            )}
        </div>
    );
};

export default VendorProfileHeader;